import React, {useReducer, useState, useEffect, useRef} from "react";
import axios from "axios";
import Packs from "./packs";

/**
 * This file is a completely isolated super component that adds a layer of service calling and
 * what packages to render and whatsoever
 * Basically instead of defining the JSON in the window's global prop you pass it as a prop to <Packs> component
 * and you get the JSON from an external service.
 * To the <Packs> component it's like nothing changed, it gets its bundles as a prop and it renders them accordingly
 * but this component is handling all the logic associated with getting the JSON and providing it to <Packs>
 *
 * ISites = window var
 * <script type="text/javascript" src="//auth-conteudos.qa.meo.pt/Style Library/consumo/js/ISites.Configurations.js?v=41"></script>
 *
 */

// const ISites = {
// 	Configurations : {
// 		Site : {
// 			Name: 'MEO'
// 		},
// 		Apps: {
// 			ISellFrontEnd: {
// 				Url : "https://app-9015f501-af0b-463a-b954-ab7059b01626.apps.qa.meo.pt"
// 			}
// 		}
// 	}
// }

// simple store state:
// "requesting" is an object that contains the id's that are pending response
// "bundles" is an object that server as store to the loaded bundles (if it's loaded then it's ID is a key in this object)
// "bundleNames" is an array that has the bundles' IDs  to render in the page
const initialState = {requesting: {}, bundles: {}, bundleNames: []};

// reducer for the store, to handle the possible actions
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_BUNDLE_PENDING": {
      return {
        ...state,
        requesting: {
          ...state.requesting,
          [action.payload.bundleName]: true,
        },
      };
    }
    case "REQUEST_BUNDLE_SUCCESS": {
      const bundleName = action.payload.bundleName;
      //console.log(bundleName);
      //console.log(action.payload.bundle);

      // solução temporária: é necessário checkar se o url é passado e a partir daí criar logo o event de clicktocall no packheader
      if (action.payload.bundle.url === undefined) {
        //action.payload.bundle.url = ISites.Configurations.Apps.ISellFrontEnd.Url + "/api/FixedOffer/CreateOrderConfigurator?catalogId=00099999188"
        action.payload.bundle.url = null;
        return {
          ...state,
          requesting: {
            ...state.requesting,
            [bundleName]: false,
          },
          bundles: {
            ...state.bundles,
            [bundleName]: {
              ...action.payload.bundle,
            },
          },
        };
      } else {
        return {
          ...state,
          requesting: {
            ...state.requesting,
            [bundleName]: false,
          },
          bundles: {
            ...state.bundles,
            [bundleName]: {
              ...action.payload.bundle,
              // you might wonder why is this here...
              // well the service that returns the bundle does not know it's "url"
              // like such it returns a key for us, the pinacle of knowledge, to replace
              // such key is {{APP_URL}} we replace it for the ISell service URL
              url:
                action.payload.bundle.url.replace(
                  "{{APP_URL}}",
                  ISites.Configurations.Apps.ISellFrontEnd.Url
                ) || null,
            },
          },
        };
      }
    }
    case "ADD_BUNDLE": {
      const bundleName = action.payload.bundleName;
      return {
        ...state,
        bundleNames:
          state.bundleNames.indexOf(bundleName) == -1
            ? state.bundleNames.concat(bundleName)
            : state.bundleNames.sort((a, b) =>
                a == bundleName ? 1 : b == bundleName ? -1 : 0
              ),
      };
    }
    case "REMOVE_BUNDLE": {
      const bundleName = action.payload.bundleName;
      return {
        ...state,
        bundleNames: state.bundleNames.filter((name) => name != bundleName),
      };
    }
  }

  return state;
};

// the component starts here
const Workbench = (props) => {
  let initialStatus = {
    status: props.status ? props.status : null,
    version: props.version ? props.version : null,
  };
  const [{status, version}, setStatus] = useState(initialStatus);

  const isFirstServiceCall = useRef(true);

  // simple local state to control the input
  const [inputValue, setInputValue] = useState("");

  // store handling is here!
  const [store, dispatch] = useReducer(reducer, {
    ...initialState,
    bundleNames: props.initialBundles ? props.initialBundles : [],
  });
  //console.log(store)

  // the filtered bundles to render
  // basically every bundle that is not requesting and is loaded
  const bundles = store.bundleNames
    .filter(
      (name) => !store.requesting[name] && store.bundles.hasOwnProperty(name)
    )
    .map((name) => store.bundles[name]);

  // set New Status to load new bundle
  const setNewStatus = (inputValue) => {
    setStatus(() => ({
      status: 1,
      version: null,
    }));

    dispatch({
      type: "ADD_BUNDLE",
      payload: {bundleName: inputValue},
    });
  };

  // function to load a given bundle by it's ID
  // it uses an external variable to know where to get the bundles
  // see below the url prop for further info
  const loadBundle = (bundle) => {
    dispatch({type: "REQUEST_BUNDLE_PENDING", payload: {bundleName: bundle}});

    if (isFirstServiceCall.current) {
      isFirstServiceCall.current = false;
    }

    const urlService = `${
      ISites.Configurations.Apps.ISellFrontEnd.Url
    }/api/FixedOffer/${
      props.getServiceType ? props.getServiceType : "GetCatalogBundle"
    }?catalogsNames=${bundle}${status ? "&status=" + status : ""}${
      version && version.length > 0 ? "&version=" + version : ""
    }`;
    // 	storeId=${
    // 	// aparentemente n é necessário passar o storeId
    //   // no futuro passar tudo a ser com IsellStoreId
    //   ISites.Configurations.Apps.IsellStoreId
    //     ? ISites.Configurations.Apps.IsellStoreId
    //     : ISites.Configurations.Site.Name === "MEO"
    //     ? 1
    //     : 2
    // }&catalogsNames=${bundle}${status ? "&status=" + status : ""}${
    //   version && version.length > 0 ? "&version=" + version : ""
    // }`;
    /* console.log(version, version.length) */
    axios({
      method: "GET",
      url: urlService,
    })
      .then((response) => {
        if (response.status == 200 && response.data.length > 0) {
          dispatch({
            type: "REQUEST_BUNDLE_SUCCESS",
            payload: {bundleName: bundle, bundle: response.data[0]},
          });
        }
      })
      .catch(console.log);
  };

  // a side effect to changes on the bundle names is to get fetch the ones you don't have
  useEffect(() => {
    store.bundleNames
      .filter(
        (name) => store.requesting[name] || !store.bundles.hasOwnProperty(name)
      )
      .forEach(loadBundle);
  }, [store.bundleNames]);

  /*

	setStatus(currentStatus => ({
		...currentStatus,
		status : 1,
		version : null
	})) 
						
	*/

  // can't get any simpler than this.
  return (
    <section className="pacotes-workbench">
      {!props.hideUI && (
        <aside>
          <div>
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Nome do pacote"
            />
            <button
              type="button"
              onClick={() => {
                setNewStatus(inputValue);
              }}
            >
              Adicionar pacote activo
            </button>
          </div>
          <ul>
            {store.bundleNames.map((name, idx) => (
              <li key={name + idx}>
                <p>{name}</p>
                <button type="button" onClick={loadBundle.bind(null, name)}>
                  Reload
                </button>
                <button
                  type="button"
                  onClick={dispatch.bind(null, {
                    type: "REMOVE_BUNDLE",
                    payload: {bundleName: name},
                  })}
                >
                  Remover
                </button>
              </li>
            ))}
          </ul>
        </aside>
      )}
      {bundles.length > 0 ? (
        <Packs resume={props.resume || false} bundles={bundles} />
      ) : null}
    </section>
  );
};

export default Workbench;
